"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "vtob_lang";

function getStoredLang(): "de" | "en" {
  if (typeof window === "undefined") return "de";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === "en" ? "en" : "de";
}

export default function LanguageBar() {
  const [lang, setLang] = useState<"de" | "en">("de");

  useEffect(() => {
    const active = getStoredLang();
    setLang(active);
    document.documentElement.lang = active;
  }, []);

  function onChange(next: "de" | "en") {
    setLang(next);
    window.localStorage.setItem(STORAGE_KEY, next);
    document.documentElement.lang = next;
    window.dispatchEvent(new CustomEvent("vtob-lang-change", { detail: next }));
  }

  return (
    <header className="vtob-topbar">
      <div className="vtob-topbar-inner">
        <div className="vtob-brand">
          <span className="vtob-brand-title">vtob_fin@healthcare</span>
          <span className="vtob-brand-sub">
            {lang === "de" ? "Interne Nutzung" : "Internal use only"}
          </span>
        </div>

        <nav className="vtob-nav">
          <a href="/idee-erfassen">
            {lang === "de" ? "Idee erfassen" : "Capture idea"}
          </a>
          <a href="/plan-generieren">
            {lang === "de" ? "Plan generieren" : "Generate plan"}
          </a>
          <a href="/projekte">{lang === "de" ? "Projekte" : "Projects"}</a>
          <select
            className="vtob-lang-select"
            value={lang}
            onChange={(e) => onChange(e.target.value as "de" | "en")}
            aria-label="Language selector"
          >
            <option value="de">DE</option>
            <option value="en">EN</option>
          </select>
        </nav>
      </div>
    </header>
  );
}
